import React from "react";

interface Props {
  box: {
    height: number;
    left: number;
    top: number;
    width: number;
  };
  isTalker: boolean;
  stream: OT.Stream;
}

const SessionVideoStream = React.forwardRef<HTMLDivElement, Props>(
  ({ box, isTalker, stream }, ref) => (
    <div className="stream-wrapper">
      <div
        className={`stream ${isTalker ? "ot_talker" : ""}`}
        id={stream.streamId}
        ref={ref}
      />
      <div className="name-wrapper">
        <p>{stream.name}</p>
      </div>
      <style jsx>{`
        .name-wrapper {
          background: black;
          position: absolute;
          left: 2px;
          bottom: 2px;
          padding: 0 5px;
          border-top-right-radius: 5px;
          z-index: 1;
        }
        .stream-wrapper {
          height: ${box.height}px;
          width: ${box.width}px;
          left: ${box.left}px;
          top: ${box.top}px;
          position: absolute;
        }
        .stream {
          height: 100%;
          width: 100%;
          position: absolute;
          border: 2px solid black;
        }
        .stream-info {
          height: 100%;
          width: 100%;
          position: absolute;
        }
        .name-wrapper p {
          color: white;
          font-size: 1.1rem;
          margin: 0;
        }
        .ot_talker {
          border: 2px solid limegreen !important;
        }
        .stream-wrapper {
          transition-property: all;
          transition-duration: 0.5s;
        }
      `}</style>
    </div>
  ),
);

export default SessionVideoStream;
